import { cn } from '@forest/shared'

interface FeatureItemProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  text: string
  className?: string
  iconClassName?: string
}

export function FeatureItem({
  icon: Icon,
  text,
  className,
  iconClassName,
}: FeatureItemProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div
        className={cn(
          'flex size-10 shrink-0 items-center justify-center',
          iconClassName,
        )}
      >
        <Icon className="size-full" />
      </div>
      <span className="text-base font-semibold text-white">{text}</span>
    </div>
  )
}
